/**
 * Vult verborgen formuliervelden met het product waar de aanvraag vandaan komt.
 *
 * Bron van het product, in volgorde van betrouwbaarheid:
 *   1. ?product=<handle> in de URL  (expliciet meegegeven door een link op de PDP)
 *   2. de referrer, als de bezoeker rechtstreeks vanaf een /products/-pagina kwam
 *
 * De gevonden waarde wordt 1 dag in sessionStorage bewaard, zodat hij niet verloren
 * gaat als de bezoeker eerst nog een andere pagina aandoet voor het versturen.
 *
 * Vul elk veld met [data-product-field] dat je in een formulier plaatst.
 */
(function () {
  var STORAGE_KEY = 'akw_product_context';

  function fromQuery() {
    try {
      var value = new URLSearchParams(window.location.search).get('product');
      return value ? value.trim() : '';
    } catch (e) {
      return '';
    }
  }

  function fromReferrer() {
    if (!document.referrer) return '';
    try {
      var url = new URL(document.referrer);
      if (url.hostname !== window.location.hostname) return '';
      var match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function read() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function store(value) {
    try {
      sessionStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* privémodus: dan werkt het alleen binnen deze paginaweergave */
    }
  }

  function populate() {
    var fields = document.querySelectorAll('[data-product-field]');
    if (!fields.length) return;

    var value = fromQuery() || fromReferrer();
    if (value) {
      store(value);
    } else {
      value = read();
    }
    if (!value) return;

    fields.forEach(function (field) {
      if (!field.value) field.value = value;
    });
  }

  document.addEventListener('DOMContentLoaded', populate);
  window.addEventListener('load', populate);
})();
